import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';
import useSWRMutation from 'swr/mutation';

interface AddressWatcherInfo {
  symbol: string;
  address: string;
  account: number;
  label: string;
  erasable: number;
}
/**
 * useWatcherAddressRemoveMutation
 */
export default function useWatcherAddressRemoveMutation() {
  return useSWRMutation(
    '/api/v1/watcher/address/delete',
    (
      url,
      {
        arg,
      }: {
        arg: {
          symbol: string;
          address: string;
        };
      }
    ) => request.post<ResponseObject<AddressWatcherInfo>>(url, arg)
  );
}
